var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('timer-button',{ref:"timerButton",staticClass:"rate-archive-button",attrs:{"manual":"","props":_vm.props},on:{"click":_vm.click,"timeout":function () { return _vm.$emit('timeout'); }}},[_vm._v("\n  "+_vm._s(_vm._value ? "RESTORE" : "ARCHIVE")+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b913936","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rate/RateArchiveButton.vue
// module id = null
// module chunks = 